import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { theme } from '../../theme';

function ProtectedRoute({ children, allowedRoles = [] }) {
  const { isAuthenticated, user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          background: theme.pageBg,
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        <div
          style={{
            width: '48px',
            height: '48px',
            border: `4px solid ${theme.border}`,
            borderTop: `4px solid ${theme.primary}`,
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
          }}
        />
        <p style={{ color: theme.textMuted, fontSize: '0.9rem' }}>Loading Bonton Suite...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.must_change_password) {
    return <Navigate to="/change-password" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          flexDirection: 'column',
          gap: '1rem',
          padding: '2rem',
        }}
      >
        <div style={{ fontSize: '4rem' }}>🔒</div>
        <h2 style={{ color: theme.text, margin: 0 }}>Access Denied</h2>
        <p style={{ color: theme.textMuted, textAlign: 'center', maxWidth: '400px' }}>
          You don't have permission to access this page. Contact your administrator if you believe this
          is an error.
        </p>
        <p style={{ color: theme.textMuted, fontSize: '0.85rem' }}>
          Your role: <strong>{user?.role}</strong>
        </p>
      </div>
    );
  }

  return children;
}

export default ProtectedRoute;
